<template>
  <div class="modal-container clearfix">
    <vxe-form
        ref="xForm"
        class="my-form2"
        title-align="right"
        title-width="110"
        :data="formData"
        :rules="formRules">
      <vxe-form-item title="纳税人名称" field="userIdSign" span="12">
        <template>
          <div v-if="!isDetail && !noEdit" class="input-border" style="display: flex;align-items: center;">
            <per-account class="corp"
                         :row="formData"
                         :field="'userName'"
                         :placeholder="'请选择'" @select="setAcc"></per-account>
          </div>
          <span v-else>{{ formData.userName }}</span>
        </template>
      </vxe-form-item>
      <vxe-form-item title="证件号码" field="idcardNum" span="12">
        <template>
          <vxe-input v-if="!isDetail" v-model="formData.idcardNum" disabled></vxe-input>
          <span v-else>{{ formData.idcardNum }}</span>
        </template>
      </vxe-form-item>
      <vxe-form-item title="手机号" field="regisiterNum" span="12">
        <template>
          <vxe-input v-if="!isDetail" v-model="formData.regisiterNum" disabled></vxe-input>
          <span v-else>{{ formData.regisiterNum }}</span>
        </template>
      </vxe-form-item>
      <vxe-form-item title="纳税人识别号" field="taxNum" span="12">
        <template v-slot="scope">
          <vxe-input v-if="!isDetail" v-model="formData.taxNum" placeholder="请输入纳税人识别号"
                     @input="$refs.xForm.updateStatus(scope)"></vxe-input>
          <span v-else>{{ formData.taxNum }}</span>
        </template>
      </vxe-form-item>
      <vxe-form-item title="税务机关" field="taxId" span="12">
        <template v-slot="scope">
          <div style="display:flex;align-items:center;height: 58px">
            <Select v-if="isEdit" v-model="formData.taxId" @on-change="$refs.xForm.updateStatus(scope)">
              <Option v-for="(item,index) in taxList" :value="item.id" :key="index">{{ item.taxComp }}</Option>
            </Select>
            <span v-else>{{ formData.taxComp }}</span>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="授权委托书" field="authImageUrl" span="12">
        <template>
          <upload-list
              :width="58"
              :height="58"
              :isEdit="isEdit"
              :row="authImage"
              :initFileList="authImageList"
              :view="'arrange'"
              style="height: 58px"
          ></upload-list>
        </template>
      </vxe-form-item>
      <vxe-form-item title="身份证正面" field="idcardFrontUrl" span="12">
        <template>
          <upload-list
              :width="58"
              :height="58"
              :isEdit="false"
              :row="idcardFrontUrl"
              :initFileList="idcardFrontUrlList"
              :view="'arrange'"
          ></upload-list>
        </template>
      </vxe-form-item>
      <vxe-form-item title="身份证反面" field="idcardBackUrl" span="12">
        <template>
          <upload-list
              :width="58"
              :height="58"
              :isEdit="false"
              :row="idcardBackUrl"
              :initFileList="idcardBackUrlList"
              :view="'arrange'"
          ></upload-list>
        </template>
      </vxe-form-item>
    </vxe-form>
    <div class="modal-footer add-btn-box">
      <Button @click="close" style="width: 100px" v-if="!isDetail">取 消</Button>
      <Button type="primary" style="width: 100px" @click="commit" v-if="!isDetail">确 定</Button>
      <Button type="primary" style="width: 100px" @click="goUpdate" v-if="isDetail && isHavePermission('taxInfo:updateTaxpayer')" >编 辑</Button>
    </div>
  </div>
</template>
<script>

import $api from "@/apiProvider";
import {hideLoading, isEmpty, showLoading} from "@/utils/util";
import PerAccount from "@/components/taxInfo/PerAccount";
import UploadList from "@/components/common/UploadList";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  props: ['taxList'],
  components: {PerAccount, UploadList},
  mixins: [getAuthOrization],
  data() {
    return {
      noEdit: false,
      searchLoading: false,
      formData: {
        id: null,
        userName: null,
        regisiterNum: null,
        idcardNum: null,
        taxNum: null,
        userIdSign: null,
      },
      taxOption: [],
      formRules: {
        userIdSign: [{required: true, message: "请选择个人用户"}],
        idcardNum: [{required: true, message: "请选择个人用户"}],
        regisiterNum: [{required: true, message: "请选择个人用户"}],
        taxNum: [{required: true, message: "请输入纳税人识别号"}],
        taxId: [{required: true, message: "请选择税务机关"}],
      },
      isEdit: true,
      isDetail: false,
      authImage: {},
      authImageList: [],
      idcardFrontUrl: {},
      idcardFrontUrlList: [],
      idcardBackUrl: {},
      idcardBackUrlList: [],
    }
  },
  methods: {
    setAcc(row) {
      this.clearV();
      this.$set(this.formData, 'userIdSign', row.id);
      this.$set(this.formData, 'userName', row.realName);
      this.$set(this.formData, 'regisiterNum', row.regisiterNum);
      this.$set(this.formData, 'idcardNum', row.idcardNum);
      this.$set(this.formData, 'taxNum', row.idcardNum);
      this.idcardFrontUrlList = [];
      this.idcardBackUrlList = [];
      this.idcardFrontUrlList.push({
        url: row.idcardFrontUrl
      });
      this.idcardBackUrlList.push({
        url: row.idcardBackUrl
      });
    },
    clearV() {
      this.$refs.xForm.clearValidate();
    },
    goUpdate() {
      this.$emit('update');
      this.isDetail = false;
      this.noEdit = true;
      this.isEdit = true;
    },
    init() {
      this.formData = {};
      this.isDetail = false;
      this.isEdit = true;
      this.idcardFrontUrlList = [];
      this.idcardBackUrlList = [];
    },
    setEdit(id) {
      this.isDetail = false;
      this.noEdit = true;
      this.isEdit = true;
      this.getClientTaxInfo(id);
    },
    setDetail(id) {
      this.isEdit = false;
      this.isDetail = true;
      this.getClientTaxInfo(id);
    },
    async getClientTaxInfo(id) {
      let res = await $api.tax.post("getClientTaxInfo", {
        id: id
      });
      if (res.status === 1) {
        let data = res.data;
        this.formData.id = data.id;
        this.formData.userIdSign = data.userIdSign;
        this.formData.userName = data.userName;
        this.formData.regisiterNum = data.regisiterNum;
        this.formData.idcardNum = data.idcardNum;
        this.formData.taxNum = data.taxNum;
        this.$set(this.formData, 'taxComp', data.taxComp);
        this.formData.taxId = data.taxId;
        this.idcardFrontUrlList = [];
        this.idcardBackUrlList = [];
        this.authImageList = [];
        this.idcardFrontUrlList.push({
          url: data.idcardFrontUrl
        });
        this.idcardBackUrlList.push({
          url: data.idcardBackUrl
        });
        if (data.authImageUrl) {
          data.authImageUrl.map(i=>{
            this.authImageList.push({
              url: i
            });
          })
        }
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async validEvent() {
      let errMap = await this.$refs.xForm.validate().catch((errMap) => errMap);
      return errMap ? false : true;
    },
    async commit() {
      let sts = await this.validEvent();
      if (!sts) {
        return;
      }
      if (!this.formData.id) {
        this.createClientTaxInfo();
      } else {
        this.updateClientTaxInfo();
      }
    },
    async createClientTaxInfo() {
      showLoading();
      let authImageUrl = [];
      this.authImage.fileNewList.map(i => {
        authImageUrl.push(i.response.data.url);
      })
      let res = await $api.tax.post("createClientTaxInfo", {
        taxId: this.formData.taxId,
        taxNum: this.formData.taxNum,
        userIdSign: this.formData.userIdSign,
        authImageUrl: authImageUrl
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("添加成功");
        this.close();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async updateClientTaxInfo() {
      showLoading();
      let authImageUrl = [];
      this.authImage.fileNewList.map(i => {
        authImageUrl.push(i.response.data.url);
      })
      let res = await $api.tax.post("updateClientTaxInfo", {
        id: this.formData.id,
        taxId: this.formData.taxId,
        taxNum: this.formData.taxNum,
        userIdSign: this.formData.userIdSign,
        authImageUrl: authImageUrl
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("修改成功");
        this.close();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close() {
      this.formData = {};
      this.isDetail = false;
      this.isEdit = true;
      this.idcardFrontUrlList = [];
      this.idcardBackUrlList = [];
      this.$emit('close');
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getList(query, options, url, path, columnType) {
      let params = {
        cate: columnType,
        name: query,
      };
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data;
        this[options] = [];
        data.map((i, index) => {
          if (index < 10) {
            this[options].push(i);
          }
        });
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
  }
}
</script>
<style scoped>
.modal-footer {
  padding: 10px 0;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  width: 96%;
  position: absolute;
  bottom: 0;
}

.input-border {
  border: 1px solid #dcdfe6;
  height: 34px;
  border-radius: 4px;
  padding: 0 .6em;
}

.input-border a, .input-border span {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  line-height: 34px;
}
</style>